export default __webpack_public_path__ + "6a7ea275e9a8901e165ebb41c6324ef7.ply";